<template>
  <v-container>
    <div>
      <v-row>
        <v-col>
          <month-picker v-model="reportMonth" outlined label="Report Month" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            :loading="schrLoading"
            outlined
            block
            color="primary"
            @click="sendCategoryHitsReport"
            >{{ reportMonth }} : Category Hits Report</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            :loading="sshrLoading"
            outlined
            block
            color="primary"
            @click="sendSuburbHitsReport"
            >{{ reportMonth }} : Suburb Hits Report</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            :loading="sphrLoading"
            outlined
            block
            color="primary"
            @click="sendProfileHitsReport"
            >{{ reportMonth }} : Profile Hits Report</v-btn
          >
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            :loading="sthrLoading"
            outlined
            block
            color="primary"
            @click="sendTagHitsReport"
            >{{ reportMonth }} : Xref Hits Report</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            :loading="strhrLoading"
            outlined
            block
            color="primary"
            @click="processAndSendTransactions"
            >{{ reportMonth }} : Transaction Report</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            :loading="sechrLoading"
            outlined
            block
            color="primary"
            @click="generateAndSendExpiringContracts"
            >{{ reportMonth }} : Expiring Contract Report</v-btn
          >
        </v-col>
      </v-row>

      <v-row class="mb-5">
        <v-col>
          <v-btn
            :loading="tmrLoading"
            outlined
            block
            color="primary"
            @click="generateAndSendTextMessageReport"
            >{{ reportMonth }} : Text Message Report</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            :loading="flrLoading"
            outlined
            block
            color="primary"
            @click="generateAndSendFreeListingReport"
            >{{ reportMonth }} : free listing report</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            :loading="plrLoading"
            outlined
            block
            color="primary"
            @click="generateAndSendPriorityListingReport"
            >{{ reportMonth }} : priority listing report</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row>
        <v-col>
          <VisitorsCard
            :visitorsAndPageViews="visitorsAndPageViews"
          ></VisitorsCard>
        </v-col>
        <v-col>
          <page-views-card
            :visitorsAndPageViews="visitorsAndPageViews"
          ></page-views-card>
        </v-col>
        <!-- <v-col>
          <category-dashboard-card></category-dashboard-card>
        </v-col> -->
      </v-row>
      <v-row>
        <most-visited-pages></most-visited-pages>
      </v-row>
      <v-row>
        <total-visits></total-visits>
      </v-row>
      <v-row>
        <visited-pages></visited-pages>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import VisitorsCard from '../../components/VisitorsCard'
import PageViewsCard from '../../components/PageViewsCard'
import MostVisitedPages from '../../components/MostVisitedPages'
import TotalVisits from '../../components/TotalVisits.vue'
import VisitedPages from '../../components/VisitedPages.vue'

import { axios } from '../../utils'
import MonthPicker from '../../components/MonthPicker.vue'
export default {
  props: {},
  data() {
    return {
      visitorsAndPageViews: [],
      schrLoading: false,
      sshrLoading: false,
      sphrLoading: false,
      sthrLoading: false,
      strhrLoading: false,
      sechrLoading: false,
      tmrLoading: false,
      flrLoading: false,
      plrLoading: false,
      reportMonth: new Date().toISOString().substr(0, 7)
    }
  },
  components: {
    VisitorsCard,
    PageViewsCard,
    TotalVisits,
    VisitedPages,
    // EmployeeDashboardCard,
    // QuoteDashboardCard,
    // SponsoredListingDashboardCard,
    // SuburbDashboardCard,
    MonthPicker,
    MostVisitedPages
  },

  mounted() {
    console.log(
      'hello',
      this.reportMonth.split('-')[1],
      this.reportMonth.split('-')[0]
    )
    axios
      .get('/api/admin/analytics/total-visitors-and-page-views')
      .then(({ data }) => (this.visitorsAndPageViews = data))
      .catch(err => console.log(err))
  },
  methods: {
    sendCategoryHitsReport() {
      if (
        confirm(
          'This will generate and send category hits report for last month..'
        )
      ) {
        this.schrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendCategoryViews?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.schrLoading = false))
      }
    },
    sendSuburbHitsReport() {
      if (
        confirm(
          'This will generate and send suburb hits report for last month..'
        )
      ) {
        this.sshrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendSuburbViews?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.sshrLoading = false))
      }
    },
    sendProfileHitsReport() {
      if (
        confirm(
          'This will generate and send profile hits report for last month..'
        )
      ) {
        this.sphrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendProfileViews?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.sphrLoading = false))
      }
    },
    sendTagHitsReport() {
      if (
        confirm('This will generate and send Xref hits report for last month..')
      ) {
        this.sthrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendTagViews?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.sthrLoading = false))
      }
    },
    processAndSendTransactions() {
      if (
        confirm(
          'This will process and send Transaction report for last month..'
        )
      ) {
        this.strhrLoading = true
        axios
          .get(
            `api/admin/schedule/processAndSendTransactions?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.strhrLoading = false))
      }
    },
    generateAndSendExpiringContracts() {
      if (
        confirm('This will  send Expiring Contracts report for this month..')
      ) {
        this.sechrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendExpiringContracts?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.sechrLoading = false))
      }
    },
    generateAndSendTextMessageReport() {
      if (confirm('This will  send Text Message report for last month..')) {
        this.tmrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendTextMessageReport?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.tmrLoading = false))
      }
    },
    generateAndSendFreeListingReport() {
      if (confirm('This will send Free Listing report for last month..')) {
        this.flrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendFreeListingReport?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.flrLoading = false))
      }
    },
    generateAndSendPriorityListingReport() {
      if (confirm('This will send Priority Listing report for last month..')) {
        this.plrLoading = true
        axios
          .get(
            `api/admin/schedule/generateAndSendPriorityListingReport?month=${
              this.reportMonth.split('-')[1]
            }&year=${this.reportMonth.split('-')[0]}`
          )
          .then(res => console.log(res.data))
          .catch(err => console.log(err))
          .finally(() => (this.plrLoading = false))
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
